var universal = { exports: {} };
export {
  universal as __module
};
//# sourceMappingURL=universal.js.map
